// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import { GanttChart as Chart } from 'components';
// import { ContainerChangeTime } from 'containers/GranttChart';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
import { userRole } from 'constant';
import { userData } from 'pages/Login/selectors';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { WorkerShift } from 'types';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import { Spin } from 'antd';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
import ModalEnterInformation from '../ModalEnterInformation';
import ModalOutputRKY from '../ModalOutputRKY';
// 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
// import { siteTabSelector } from '../selectors';
// 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
import SectionStyled from './styles';
type Props = {
  dataChart: WorkerShift[];
  setCurrentDate: (date: Date) => void;
  currentDate: Date | string;
  loading?: boolean;
};

const GranttChart: FC<Props> = ({ dataChart, setCurrentDate, currentDate, loading }) => {
  const { roleUser } = useSelector(userData);
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
  // const dataTabs = useSelector(siteTabSelector);
  // 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end
  return (
    <SectionStyled>
      <div className="box-top">
        {/* {roleUser !== userRole.BO && dataTabs && ( */}
        {roleUser !== userRole.BO && (
          <div className="box-button">
            {/* removebutton enterinfomation */}
            {roleUser !== userRole.CM && (
              <div className="button-left-margin">
                <ModalEnterInformation />
              </div>
            )}
            {/* <ModalOutputRKY dataCooperator={dataTabs} /> */}
            <ModalOutputRKY />
          </div>
        )}
      </div>
      {/* 2023/10/10 Leading Win 作業員シフト表廃止対応 start*/}
      {/* <div className="box-chart">
        <div className="box-date-time mb-8">
          <span className="header-chart">スケジュール</span>
          <ContainerChangeTime
            onChangeDate={setCurrentDate}
            currentDateProps={currentDate}
            showIconDate={true}
            formatChangeDateTime={'YYYY/MM'}
            type="month"
          />
        </div>
        {loading ? (
          <div className="example-spin">
            <Spin size="large" />
          </div>
        ) : (
          <Chart
            width={'auto'}
            type={'group'}
            data={dataChart}
            onChangeDate={setCurrentDate}
            currentDate={currentDate}
          />
        )}
      </div> */}
      {/* 2023/10/10 Leading Win 作業員シフト表廃止対応 end */}
    </SectionStyled>
  );
};
export default GranttChart;
